var exports = {
  "Dk": "xfd349460--fba0f9--carousel",
};

module.exports = exports;
